import React from 'react';
import { DollarSign, Repeat, Plug, Timer } from 'lucide-react';

const STATS = [
  {
    icon: DollarSign,
    label: 'Saved per order on average',
    value: '$100',
    methodology:
      'Median delta between the first carrier accepted and the lowest qualified bid on the same load, across Vibe Engine customers (2024–2025).',
  },
  {
    icon: Repeat,
    label: 'Loads tendered automatically',
    value: '98%',
    methodology:
      'Share of tenders completed without manual broker outreach after automation rules are active.',
  },
  {
    icon: Timer,
    label: 'Time saved per tender vs. manual',
    value: '12 min',
    methodology:
      'Average reduction in tender cycle time (offer sent → carrier awarded) vs. manual phone/email workflows, from customer benchmark data.',
  },
  {
    icon: Plug,
    label: 'TMS & ERP integrations',
    value: 'SAP · Turvo · more',
    methodology:
      'Pre-built and custom connectors for leading TMS, ERP, and WMS platforms.',
  },
];

export default function StatsBar() {
  return (
    <section className="border-y border-ink-200 bg-ink-50">
      <div className="container-page py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-6">
          {STATS.map((s) => (
            <div key={s.label} className="flex items-start gap-3">
              <span className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white border border-ink-200 text-ink-900">
                <s.icon className="h-4 w-4" />
              </span>
              <div>
                <div className="text-2xl font-semibold text-ink-900 tabular-nums">
                  {s.value}
                </div>
                <div className="text-sm text-ink-600 mt-0.5">{s.label}</div>
                <p className="mt-2 text-xs text-ink-500 leading-relaxed">
                  {s.methodology}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
